export const PENDING_APPROVALS_CONTAINER_TAG_NAME = 'pending-approvals-container';
